const FullScreenLoader = () => {
  console.info("LOADING...");
  return <div>...</div>;
};

export default FullScreenLoader;
